<!--  家校训练服务-详情-评估结果-评估答题 -->
<template>
  <div class="answer">
    <div class="content-container">
      <div class="field">
        <div
          class="field_l"
        >当前评估领域：{{ field || '-' }}{{ currentQuestion.field ? '-'+currentQuestion.field.name : '' }}</div>
        <div>
          <a-button shape="round" class="custom-button" @click="viewAnswer()">查看已答题目</a-button>
          <a-button shape="round" @click="$emit('return')">
            <a-icon type="left" />返回评估领域
          </a-button>
        </div>
      </div>
      <div v-if="subjectList && subjectList.length > 0">
        <div class="code">题目编号：{{ formatCode || '--' }}</div>
        <div class="title">
          <div class="title-l">题干：{{ currentQuestion.questionStem || '--' }}</div>
          <!-- 答题进度 -->
          <div class="answer-progress">
            当前答题进度：
            <span>{{ answeredAndSkippedCount || '--' }}</span>
            <span>/{{ totalSubjectCount || '--' }}</span>
          </div>
        </div>
        <span class="example">
          <span class="example-l" v-if="currentQuestion.instance">示例：{{ currentQuestion.instance }}</span>
          <a-button
            type="link"
            @click="viewInformation"
            v-if="currentQuestion.resourceList && currentQuestion.resourceList.length"
          >{{ pictureOrVideo === 'VIDEO' ? '查看视频' : pictureOrVideo === 'IMAGE' ? '查看图片' : '' }}</a-button>
        </span>
        <div class="description">
          <span class="type">多选题</span>请在以下选项中，选出符合儿童情况的所有选项
        </div>
        <div class="option">
          <!-- 普通选项 -->
          <a-checkbox-group v-model="currentQuestion.selectOptions" style="width: 100%">
            <div
              v-for="(item, index) in currentQuestion.optionList"
              class="option-box"
              v-if="item.score != 0 && item.id !== -1"
              :key="index"
              :class="currentQuestion.selectOptions.indexOf(item.id) === -1 ? '' : 'active'"
            >
              <a-checkbox
                :value="item.id"
                :disabled="currentQuestion.choiceAll || currentQuestion.allHave"
                @change="handleOptionChange"
              >
                <div
                  class="option-description"
                  :class="currentQuestion.selectOptions.indexOf(item.id) === -1 ? '' : 'hot'"
                >{{ item.description }}</div>
              </a-checkbox>
            </div>
          </a-checkbox-group>
          <!-- 最后一行：以上行为均具备 + 以上行为均不具备 -->
          <div class="option-box option-row-last">
            <a-checkbox
              :checked="currentQuestion.allHave"
              :disabled="!canAllHave"
              @change="handleAllHaveChange"
            >
              <div class="option-description">
                以上行为均具备
                <a-icon type="check" :style="{ color: '#3a5ff8' }" />
              </div>
            </a-checkbox>
            <!-- 原有的"以上行为均不具备"，保持原样 -->
            <a-checkbox v-model="currentQuestion.choiceAll" @change="changeNoOption">
              <div class="option-description">
                以上行为均不具备
                <a-icon type="close" :style="{ color: '#ff4d4f' }" />
              </div>
            </a-checkbox>
          </div>
        </div>
      </div>
      <div v-else class="no-data">
        <a-empty :description="`【${field ? field : '-'}】领域所有题目均已作答完毕，检查无误后请进行提交`" />
      </div>
    </div>

    <!-- 底部导航 -->
    <div
      v-if="subjectList && subjectList.length > 0"
      class="submit-bottom"
      :class="{ 'submit-bottom-last': isLastQuestion }"
    >
      <!-- 最后一题 -->
      <template v-if="isLastQuestion">
        <div class="prev-question" v-if="subjectIndex > 0" @click="prevQuestion()">上一题</div>
        <div class="submit" @click="submit('last')">评估完成</div>
      </template>
      <!-- 非最后一题 -->
      <template v-else>
        <div class="prev-question" v-if="subjectIndex > 0" @click="prevQuestion()">上一题</div>
        <div class="skip-subfield-btn" @click="openSkipSubFieldModal">跳过当前子领域</div>
        <div class="next-question" @click="nextQuestion({ isSubmit: false })">下一题</div>
      </template>
    </div>
    <div v-else class="submit-bottom" :class="{ 'submit-bottom-last': isLastQuestion }">
      <template>
        <div class="submit" @click="submit('overall')">提交</div>
      </template>
    </div>

    <!--播放视频-->
    <Video ref="video"></Video>

    <!-- 年龄匹配弹窗 -->
    <a-modal
      v-model="skipAgeModalVisible"
      title="信息提示"
      :closable="false"
      :maskClosable="false"
      width="480px"
    >
      <div>
        <p>{{ skipModalContent.title }}</p>
        <p>{{ skipModalContent.question }}</p>
        <p class="tip">{{ skipModalContent.tip }}</p>
      </div>
      <div slot="footer">
        <a-button :loading="skipAgeLoading" @click="handleSkipAgeNotSkip">暂不跳过</a-button>
        <a-button type="primary" :loading="skipAgeLoading" @click="handleSkipAge(true)">跳过</a-button>
      </div>
    </a-modal>

    <!-- 跳过子领域弹窗 -->
    <a-modal
      v-model="skipSubFieldModalVisible"
      title="提示"
      :closable="false"
      :maskClosable="false"
      width="480px"
    >
      <div class="skip-subfield-modal-content">
        <p class="question">是否确定跳过当前子领域后续题目？</p>
        <p class="label">请选择跳过的题目是否得分</p>
        <a-radio-group v-model="skipSubFieldResult">
          <div class="radio-option">
            <a-radio value="all_score">跳过题目均得分</a-radio>
          </div>
          <div class="radio-option">
            <a-radio value="no_score">跳过题目均不得分</a-radio>
          </div>
          <div class="radio-option">
            <a-radio value="cancel">暂不跳过</a-radio>
          </div>
        </a-radio-group>
      </div>
      <div slot="footer">
        <a-button :loading="skipSubFieldLoading" @click="handleSkipSubFieldCancel">取消</a-button>
        <a-button
          type="primary"
          :loading="skipSubFieldLoading"
          :disabled="!skipSubFieldResult"
          @click="handleSkipSubFieldConfirm"
        >确定</a-button>
      </div>
    </a-modal>

    <!-- 提交确认弹窗 -->
    <a-modal
      v-model="visible"
      width="400px"
      title="信息提示"
      :closable="false"
      :keyboard="false"
      :maskClosable="false"
      :bodyStyle="{ padding: 0 }"
      :ok-button-props="{
        props: { shape: 'round', loading: buttonLoading, disabled: buttonLoading }
      }"
      :cancel-button-props="{ props: { shape: 'round' } }"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-card style="height: 100%; overflow: auto">
        <div style="display: flex; align-content: center; align-items: center;margin-bottom: 10px;">
          <a-icon
            type="question-circle"
            style="color: #faad14; font-size: 20px; margin-right: 5px;"
          />
          确认要提交{{ field }}的评估结果吗？
        </div>
        <div>提交后，在下一次整体重新评估之前，无法修改评估结果</div>
      </a-card>
    </a-modal>
  </div>
</template>
<script>
import * as planApi from '@/api/plan'
import Video from '@/components/video'
import { mapActions } from 'vuex'

export default {
  props: {
    stuAge: {
      type: [String, Number],
      default: '',
    },
    answerData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      visible: false,
      buttonLoading: false,
      subjectIndex: 0, // 显示题目的索引
      subjectList: [], // 所有的题目
      answerCount: 0, // 已答题数量
      // 当前作答题目
      currentQuestion: {
        field: {
          name: '',
        },
        code: '',
        resourceList: [],
      },
      field: '',
      query: {
        evaluationFieldId: '', // 领域id
        totalSubject: '', // 题目总数
      },
      skipAgeModalVisible: false, // 年龄匹配弹窗
      skipAgeConfirmed: false, // 是否已确认跳过
      skipLevelConfig: {}, // 存储跳过配置，key为年龄
      skipSubFieldModalVisible: false, // 跳过子领域弹窗
      skipSubFieldResult: null, // 用户选择结果
      submitType: '', // 提交类型：last-最后一题提交，overall-整体评估提交
      skippedFields: [], // 已跳过的 field id 列表
      allSkipped: false, // 是否所有题目都已跳过
      skippedCount: 0, // 已跳过的题目总数（年龄跳过 + 子领域跳过）
      totalFixed: 0, // 固定的总题数
      skipAgeLoading: false, // 年龄匹配弹窗按钮 loading
      skipSubFieldLoading: false, // 跳过子领域弹窗按钮 loading
    }
  },
  created() {
    const { id: evaluationFieldId, totalSubject, name: field } = this.answerData
    this.query = { evaluationFieldId, totalSubject }
    this.field = field
    this.getTitleAll()
  },

  computed: {
    isLastQuestion() {
      return this.subjectIndex === this.subjectList.length - 1
    },
    // 固定的总题数
    totalSubjectCount() {
      return this.totalFixed
    },
    // 已答 + 已跳过 + 当前进度
    answeredAndSkippedCount() {
      return this.answerCount + this.skippedCount + this.subjectIndex + 1
    },
    // title最多显示3位code
    formatCode() {
      const { code } = this.currentQuestion
      const n = code && code.slice(8)
      const codeLengthLimit = 3
      return (Array(codeLengthLimit).join(0) + n).slice(-codeLengthLimit)
    },
    pictureOrVideo() {
      const { resourceList } = this.currentQuestion
      if (resourceList && resourceList.length !== 0) {
        return resourceList[0].type
      }
      return false
    },
    // 年龄匹配弹窗文案
    skipModalContent() {
      const age = parseInt(this.stuAge)
      let ageRange = ''
      if (age >= 5) {
        ageRange = '0-4岁'
      } else if (age >= 3) {
        ageRange = '0-2岁'
      }
      return {
        title: '根据孩子当前年龄',
        question: `是否需要自动作答【${this.field}】领域${ageRange}的题目？`,
        tip: '注意：跳过的题目将默认全部得分',
      }
    },
    // 判断是否可以勾选"以上行为均具备"
    canAllHave() {
      return (
        this.currentQuestion &&
        this.currentQuestion.optionList &&
        this.currentQuestion.optionList.some((o) => o.score > 0)
      )
    },
  },
  watch: {
    // 监听 selectOptions 变化，实现自动联动
    'currentQuestion.selectOptions': {
      handler(newVal, oldVal) {
        if (newVal === oldVal) return
        const scoredOptions = this.currentQuestion.optionList.filter((o) => o.score > 0)
        if (scoredOptions.length === 0) return

        const allSelected = scoredOptions.every((o) => newVal.includes(o.id))
        // 如果全部选中且用户没有主动勾选"以上行为均具备"，则自动勾选
        if (allSelected && !this.currentQuestion.allHave) {
          this.currentQuestion.allHave = true
          this.currentQuestion.choiceAll = false
        } else if (!allSelected && this.currentQuestion.allHave) {
          this.currentQuestion.allHave = false
        }
      },
      deep: true,
    },
    // 监听 choiceAll 变化
    'currentQuestion.choiceAll': {
      handler(newVal) {
        if (newVal) {
          this.currentQuestion.allHave = false
        }
      },
    },
  },
  methods: {
    ...mapActions(['changeSpinning']),

    // 拉全部题目(已答+未答)
    getTitleAll() {
      const { evaluationFieldId } = this.query
      this.changeSpinning(true)
      planApi
        .searchAllSubject(evaluationFieldId)
        .then((res) => {
          if (res.code === 0) {
            const { answerSubjectList, noAnswerSubjectList } = res.data
            // 只使用未答题目
            this.answerCount = answerSubjectList.length
            // 拼装数据
            noAnswerSubjectList.map((item) => {
              const { optionList } = item
              const notOptional = []
              const __optionList = []
              const __selectOptions = []
              optionList &&
                optionList.length &&
                optionList.forEach((item1) => {
                  const { score, isSelect, id } = item1
                  if (score === 0) {
                    notOptional.push(item1)
                    item.choiceAll = !!isSelect
                    !!isSelect && __selectOptions.push(id)
                  } else {
                    __optionList.push(item1)
                    isSelect && __selectOptions.push(id)
                  }
                })
              item.selectOptions = __selectOptions
              item.optionList = [...__optionList, ...notOptional]
              item.notOptional = notOptional
              // 前端新增"以上行为均具备"选项（id=-1）
              item.optionList.push({
                id: -1,
                description: '以上行为均具备',
                score: 0,
                serialNumber: -1,
                isSelect: false,
              })
              item.allHave = false
            })
            this.subjectList = noAnswerSubjectList
            this.subjectIndex = 0
            this.currentQuestion = this.subjectList[0] || {}
            // 计算固定总数
            this.totalFixed = answerSubjectList.length + noAnswerSubjectList.length
            this.skippedCount = 0
            // 判断是否显示年龄匹配弹窗
            this.checkSkipAgeModal()
          }
        })
        .finally(() => {
          this.changeSpinning(false)
        })
    },
    // 点击-以上都不具备
    changeNoOption() {
      if (this.currentQuestion.choiceAll) {
        // 勾选"以上均不具备"时，清空"以上均具备"和普通选项
        this.currentQuestion.allHave = false
        this.currentQuestion.selectOptions = []
      } else {
        // 取消勾选时，清空普通选项
        this.currentQuestion.selectOptions = []
      }
    },
    // 处理"以上行为均具备"勾选变化
    handleAllHaveChange(e) {
      const checked = e.target.checked
      this.currentQuestion.allHave = checked
      if (checked) {
        // 选中：清空"以上均不具备"，全选所有 score>0 的选项
        this.currentQuestion.choiceAll = false
        this.currentQuestion.selectOptions = []
        const scoredOptions = this.currentQuestion.optionList.filter((o) => o.score > 0)
        scoredOptions.forEach((o) => this.currentQuestion.selectOptions.push(o.id))
      } else {
        // 取消：清空所有普通选项
        this.currentQuestion.selectOptions = []
      }
    },
    // 普通选项变化时，检测是否全部选中
    handleOptionChange() {
      // 延迟一帧执行，确保 checkbox 状态已更新
      this.$nextTick(() => {
        const scoredOptions = this.currentQuestion.optionList.filter((o) => o.score > 0)
        const allSelected =
          scoredOptions.length > 0 && scoredOptions.every((o) => this.currentQuestion.selectOptions.includes(o.id))
        // 如果全部选中且用户没有主动勾选"以上行为均具备"，则自动勾选
        if (allSelected && !this.currentQuestion.allHave) {
          this.currentQuestion.allHave = true
        } else if (!allSelected && this.currentQuestion.allHave) {
          this.currentQuestion.allHave = false
        }
      })
    },
    // 获取提交的答案列表（排除前端新增的选项）
    getSubmitOptionIds() {
      // 如果勾选了"以上均不具备"，只提交该选项的 id
      if (this.currentQuestion.choiceAll) {
        const noneOption = this.currentQuestion.optionList.find((o) => o.score === 0 && o.serialNumber === 0)
        return noneOption ? [noneOption.id] : []
      }
      // 如果勾选了"以上均具备"，提交所有 score>0 的选项 id
      if (this.currentQuestion.allHave) {
        const scoredOptions = this.currentQuestion.optionList.filter((o) => o.score > 0)
        return scoredOptions.map((o) => o.id)
      }
      // 正常情况，提交普通选项
      return this.currentQuestion.selectOptions
    },
    // 下一题
    nextQuestion({ isSubmit }) {
      const { evaluationFieldId } = this.query
      const optionIdList = this.getSubmitOptionIds()
      const { id: subjectId } = this.currentQuestion
      if (optionIdList.length === 0) {
        this.$notification['error']({ message: '提示', description: '请回答本题' })
        return
      }
      const params = { optionIdList, evaluationFieldId, subjectId }
      this.changeSpinning(true)
      planApi
        .answer(params)
        .then((res) => {
          if (res.code === 0) {
            // 是否最后一题
            if (isSubmit) {
              planApi.evaluationSubmit(this.query.evaluationFieldId).then((res) => {
                if (res.code === 0) {
                  this.$emit('finished')
                }
              })
            } else {
              // 切换下一题
              window.scrollTo(0, 0)
              this.subjectIndex++
              this.currentQuestion = this.subjectList[this.subjectIndex]
            }
          }
        })
        .catch(() => {
          this.$notification['error']({ message: '提示', description: '保存答案失败，请重试' })
        })
        .finally(() => {
          this.changeSpinning(false)
        })
    },
    // 上一题
    prevQuestion() {
      if (this.subjectIndex === 0) return
      window.scrollTo(0, 0)
      this.subjectIndex--
      this.currentQuestion = this.subjectList[this.subjectIndex]
    },
    // 最后一题-提交
    submit(type) {
      this.submitType = type
      if (type === 'last') {
        const optionIdList = this.getSubmitOptionIds()
        if (optionIdList.length === 0) {
          this.$notification['error']({ message: '提示', description: '请回答本题' })
          return
        }
      }

      this.visible = true
    },
    // 整体提交
    overallSubmit() {
      this.changeSpinning(true)
      planApi
        .evaluationSubmit(this.query.evaluationFieldId)
        .then((res) => {
          if (res.code === 0) {
            this.$emit('finished')
          }
        })
        .catch(() => {
          this.$notification['error']({ message: '提示', description: '提交失败，请重试' })
        })
        .finally(() => {
          this.changeSpinning(false)
        })
    },
    handleOk() {
      this.buttonLoading = true
      if (this.submitType === 'last') {
        this.nextQuestion({ isSubmit: true })
      } else {
        this.overallSubmit()
      }
    },
    handleCancel() {
      this.visible = false
      this.buttonLoading = false
    },
    // 查看资料
    viewInformation() {
      const { resourceList } = this.currentQuestion
      if (resourceList && resourceList.length !== 0) {
        const { type, url } = resourceList[0]
        if (type === 'VIDEO') {
          this.$refs.video.showModal({ teachingVideo: { url } })
        }
        if (type === 'IMAGE') {
          const urls = resourceList.map((item) => item.url)
          this.$viewerApi({
            images: urls,
          })
        }
      }
    },
    // 判断是否显示年龄匹配弹窗
    checkSkipAgeModal() {
      const age = parseInt(this.stuAge)
      // 年龄小于3岁不显示
      if (age < 3) return
      // 已处理过该年龄不重复显示
      if (this.skipLevelConfig[age]) return
      // 检查是否有需要跳过的Level题目
      const skipLevels = age >= 5 ? ['LEVEL1', 'LEVEL2'] : ['LEVEL1']
      const hasSkipQuestions = this.subjectList.some((q) => skipLevels.includes(q.level))
      if (hasSkipQuestions) {
        this.skipAgeModalVisible = true
      }
    },
    // 处理年龄匹配选择
    handleSkipAge(skip) {
      this.skipAgeConfirmed = skip
      this.skipAgeModalVisible = false
      if (!skip) {
        console.log('不跳过，正常作答')
        return
      }
      // 记录跳过配置
      const age = parseInt(this.stuAge)
      const ageRange = age >= 5 ? '0-4岁' : '0-2岁'
      const skipLevels = age >= 5 ? ['LEVEL1', 'LEVEL2'] : ['LEVEL1']
      // 过滤出需要跳过的题目
      const skippedSubjects = this.subjectList.filter((q) => skipLevels.includes(q.level))

      if (skippedSubjects.length === 0) {
        console.log('没有需要跳过的题目')
        return
      }

      // 准备批量提交参数 - 将每道题的所有得分选项 id 传入，模拟全选
      const answerList = skippedSubjects.map((subject) => ({
        subjectId: subject.id,
        optionIdList: subject.optionList.filter((o) => o.score > 0).map((o) => o.id),
      }))

      const params = {
        evaluationFieldId: this.query.evaluationFieldId,
        answerList: answerList,
      }

      // 调用批量提交接口
      this.skipAgeLoading = true
      this.changeSpinning(true)
      planApi
        .saveAnswerBatch(params)
        .then((res) => {
          if (res.code === 0) {
            // 保存跳过配置
            this.skipLevelConfig[age] = {
              levels: skipLevels,
              ageRange: ageRange,
              subjects: skippedSubjects,
            }
            // 累加已跳过数量
            this.skippedCount += skippedSubjects.length
            // 跳过后重新获取题目列表
            this.getTitleAll()
            console.log('批量提交成功，跳过', skippedSubjects.length, '题')
          } else {
            this.$notification['error']({
              message: '提示',
              description: res.msg || '批量提交失败',
            })
          }
        })
        .catch(() => {
          this.$notification['error']({
            message: '提示',
            description: '批量提交失败，请重试',
          })
        })
        .finally(() => {
          this.skipAgeLoading = false
          this.changeSpinning(false)
        })
    },
    // 暂不跳过
    handleSkipAgeNotSkip() {
      this.skipAgeConfirmed = false
      this.skipAgeModalVisible = false
      console.log('不跳过，正常作答')
    },
    // 打开跳过子领域弹窗
    openSkipSubFieldModal() {
      this.skipSubFieldResult = null
      this.skipSubFieldModalVisible = true
    },
    // 查看已答题目
    viewAnswer() {
      this.$emit('viewAnswer')
    },
    // 取消
    handleSkipSubFieldCancel() {
      this.skipSubFieldModalVisible = false
      this.skipSubFieldResult = null
    },
    // 确定
    handleSkipSubFieldConfirm() {
      if (!this.skipSubFieldResult) return

      // 暂不跳过
      if (this.skipSubFieldResult === 'cancel') {
        this.skipSubFieldModalVisible = false
        this.skipSubFieldResult = null
        return
      }

      const currentFieldId = this.currentQuestion.field.id

      // 只在 subjectList 中筛选同 field 的题目
      const remainingQuestions = this.subjectList.filter((q) => q.field.id === currentFieldId)

      // 如果没有需要跳过的题目，直接关闭弹窗
      if (remainingQuestions.length === 0) {
        this.skipSubFieldModalVisible = false
        this.skipSubFieldResult = null
        return
      }

      // 准备批量提交参数
      let answerList = []

      if (this.skipSubFieldResult === 'all_score') {
        // 跳过题目均得分：提交 score > 0 的选项
        answerList = remainingQuestions.map((q) => ({
          subjectId: q.id,
          optionIdList: q.optionList.filter((o) => o.score > 0).map((o) => o.id),
        }))
      } else if (this.skipSubFieldResult === 'no_score') {
        // 跳过题目均不得分：提交 score = 0 的选项（排除前端新增的 id=-1）
        answerList = remainingQuestions.map((q) => ({
          subjectId: q.id,
          optionIdList: q.optionList.filter((o) => o.score === 0 && o.id !== -1).map((o) => o.id),
        }))
      }

      const params = {
        evaluationFieldId: this.query.evaluationFieldId,
        answerList: answerList,
      }

      // 调用批量提交接口
      this.skipSubFieldLoading = true
      this.changeSpinning(true)
      planApi
        .saveAnswerBatch(params)
        .then((res) => {
          if (res.code === 0) {
            // 记录已跳过的 field
            if (!this.skippedFields.includes(currentFieldId)) {
              this.skippedFields.push(currentFieldId)
            }

            // 从 subjectList 中移除该 field 的所有题目
            this.subjectList = this.subjectList.filter((q) => q.field.id !== currentFieldId)

            // 重置索引
            this.subjectIndex = 0
            this.currentQuestion = this.subjectList[0] || {}

            this.skipSubFieldModalVisible = false
            this.skipSubFieldResult = null

            // 提示
            this.$notification['success']({
              message: '提示',
              description: '已跳过当前子领域',
            })

            // 检查是否全部跳过
            if (this.subjectList.length === 0) {
              this.allSkipped = true
            }

            // 累加已跳过数量
            this.skippedCount += remainingQuestions.length
          } else {
            this.$notification['error']({
              message: '提示',
              description: res.msg || '跳过失败',
            })
          }
        })
        .catch(() => {
          this.$notification['error']({
            message: '提示',
            description: '跳过失败，请重试',
          })
        })
        .finally(() => {
          this.skipSubFieldLoading = false
          this.changeSpinning(false)
        })
    },
  },
  components: {
    Video,
  },
}
</script>
<style lang="less" scoped>
.answer {
  width: 100%;
  padding: 0 20px 0 20px;
  .content-container {
    width: 100%;
    background: #ffffff;
    /*领域*/
    .field {
      display: flex;
      justify-content: space-between;
      margin-bottom: 4px;
      .field_l {
        font-size: 16px;
        font-weight: 600;
        color: #000000;
        align-self: center;
      }
    }
    /*编号*/
    .code {
      font-size: 14px;
      color: #8c8c8c;
      margin-bottom: 32px;
    }
    .title {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 600;
      color: #000000;
      // 答题进度
      .answer-progress {
        display: flex;
        justify-content: center;
        font-size: 14px;
        :first-child {
          font-weight: 600;
        }
      }
    }
    .example {
      font-size: 13px;
      margin-top: 4px;
      display: inline-block;
      color: #8c8c8c;
      .example-l {
        position: relative;
      }
      .example-r {
        line-height: 1.5;
      }
    }
    img {
      width: 100%;
      height: 132px;
      margin-top: 8px;
    }
    .description {
      margin: 10px 0 10px 0;
      font-size: 14px;
      color: #000000;
      .type {
        display: inline-block;
        width: 52px;
        line-height: 21px;
        text-align: center;
        margin-right: 5px;
        color: #3350c7;
        font-size: 12px;
        border-radius: 4px;
        border: 1px solid #3a5ff8;
      }
    }
    .option {
      .option-box {
        background: #f7f8fc;
        width: 100%;
        margin-bottom: 8px;
        font-size: 14px;
        .hot {
          color: #595959;
        }

        /deep/ .ant-checkbox-wrapper {
          padding: 14px 4px;
          display: flex;
          align-items: center;
        }
      }
      .active {
        color: #595959;
      }
    }

    // 最后一行选项布局
    .option-row-last {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 48px;

      /deep/ .ant-checkbox-wrapper {
        margin-right: 0;
      }
    }
  }

  // 题目卡片样式（保留）
  .question-item {
    background: #ffffff;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 16px;
  }

  .submit-bottom {
    width: 100%;
    height: 40px;
    padding: 0 8px;
    margin-top: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;

    .next-question {
      border-radius: 20px;
      width: 160px;
      height: 100%;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      border: 1px solid #3a5ff8;
      color: #3a5ff8;
      cursor: pointer;
    }

    .prev-question {
      border-radius: 20px;
      width: 160px;
      height: 100%;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      border: 1px solid #3a5ff8;
      color: #3a5ff8;
      cursor: pointer;
      margin-right: 10px;
    }

    .submit {
      border-radius: 20px;
      width: 160px;
      height: 100%;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      background: #4760c6;
      color: #ffffff;
      cursor: pointer;
    }

    .skip-subfield-btn {
      border-radius: 20px;
      width: 160px;
      height: 100%;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      border: 1px solid #faad14;
      color: #faad14;
      cursor: pointer;
      margin: 0 10px;
    }
  }

  .submit-bottom-last {
    display: flex;
    justify-content: center;
    .submit {
      width: 160px;
      cursor: pointer;
    }
  }

  // 年龄匹配弹窗样式
  .skip-age-modal-content {
    p {
      margin: 8px 0;
      font-size: 14px;
      color: #333;
      line-height: 1.6;
    }
    .tip {
      color: #ff4d4f;
      font-size: 12px;
      margin-top: 12px;
    }
  }

  // 跳过子领域弹窗样式
  .skip-subfield-modal-content {
    .question {
      font-size: 15px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }
    .label {
      font-size: 13px;
      color: #666;
      margin-bottom: 16px;
    }
    /deep/ .ant-radio-wrapper {
      display: block;
      margin-bottom: 12px;
      padding: 8px 12px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        border-color: #3a5ff8;
        background: #f0f5ff;
      }

      &.ant-radio-wrapper-checked {
        border-color: #3a5ff8;
        background: #f0f5ff;
      }
    }
  }
}
.custom-button {
  margin-right: 10px;
  color: #3a5ff8;
  border: 1px solid #3a5ff8;
}
</style>